import { iHolidayQuoteItineraryBlock } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { buildPreviewHotelBlock } from "./preview-hotel-block";

export function buildPreviewItineraryBlocks(): iHolidayQuoteItineraryBlock[] {
  return [
    {
      id: "preview-outbound-flight",
      type: "flight",
      flightData: {
        departureDate: "2026-09-12",
        departureTime: "09:15",
        departureAirport: "LHR",
        arrivalDate: "2026-09-12",
        arrivalTime: "21:40",
        arrivalAirport: "MLE",
        airline: "Qatar Airways",
        flightNumber: "QR106",
        flightCheckInTime: 180,
        cabinClass: "Business",
        handLuggageOnly: false,
        baggageAllowance: "30",
        transitTime: 120,
        operatedBy: "Qatar Airways",
        baggageNotes: "2 x 30kg checked bags per person",
      },
    },
    {
      id: "preview-arrival-transfer",
      type: "transfer",
      transferData: {
        transferDate: "2026-09-12",
        pickUpTime: "22:30",
        dropOffDate: "2026-09-12",
        dropOffTime: "23:15",
        pickUpLocation: "Velana International Airport (MLE)",
        dropOffLocation: "Sheraton Maldives Full Moon Resort & Spa",
        heading: "Airport to Resort Transfer",
        body: "After your flight lands, a resort representative will meet you at arrivals and escort you to the speedboat jetty. Enjoy a scenic 45-minute crossing to Furanafushi Island — your private island paradise awaits.",
        provider: "Sheraton Resort Transfers",
        transferType: "Shared Speedboat",
        duration: 45,
        icon: "ship",
      },
    },
    buildPreviewHotelBlock(),
    {
      id: "preview-departure-transfer",
      type: "transfer",
      transferData: {
        transferDate: "2026-09-22",
        pickUpTime: "20:00",
        dropOffDate: "2026-09-22",
        dropOffTime: "21:00",
        pickUpLocation: "Sheraton Maldives Full Moon Resort & Spa",
        dropOffLocation: "Velana International Airport (MLE)",
        heading: "Resort to Airport Transfer",
        body: "Speedboat transfer from the resort back to Velana International Airport in good time for your return flight. Your resort concierge will confirm the exact pick-up time the day before departure.",
        provider: "Sheraton Resort Transfers",
        transferType: "Shared Speedboat",
        duration: 45,
        icon: "ship",
      },
    },
    {
      id: "preview-return-flight",
      type: "flight",
      flightData: {
        departureDate: "2026-09-22",
        departureTime: "23:55",
        departureAirport: "MLE",
        arrivalDate: "2026-09-23",
        arrivalTime: "13:20",
        arrivalAirport: "LHR",
        airline: "Qatar Airways",
        flightNumber: "QR107",
        flightCheckInTime: 180,
        cabinClass: "Business",
        handLuggageOnly: false,
        baggageAllowance: "30",
        transitTime: 120,
        operatedBy: "Qatar Airways",
        baggageNotes: "2 x 30kg checked bags per person",
      },
    },
  ];
}
